import * as React from "react"
import { StaticImage } from 'gatsby-plugin-image'

interface paramIf {
  children: string
}

export default function Alice({ children }: paramIf) {
  const imagePath = `../images/alice/default.png`
  return (
    <div className="flex my-5 fukidashi">
      <StaticImage src={imagePath} className="shrink-0 rounded w-20 h-20" alt="" width={80} height={80} />
      <i className="says">{children}</i>
    </div>
  )
}
